export default "__VITE_ASSET__DPeqwwls__"